import { createOutlineIcon } from "../createIcon";

export const ChevronUpOutlineIcon = createOutlineIcon(
  <>
    <path d="M7 14.583 12 10l5 4.583" />
  </>,
  "ChevronUpOutlineIcon"
);
